const MULT = 24;
export const HERO_HEIGHT = MULT * 8;
